<div class="flex-column wrapper" *ngIf="account">
  <div class="grid">
    <app-balances [account]="account"></app-balances>
    <app-nfts [account]="account"></app-nfts>
    <app-activity [account]="account"></app-activity>
  </div>
</div>
<app-token-detail></app-token-detail>